import { useState } from "react";
import { faqs, guideSteps, submitChannels } from "../../../mocks/clueSite";

export default function SubmitGuide() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return (
    <section id="guide" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        {/* 顶部入口横幅 */}
        <div className="relative overflow-hidden rounded-lg bg-accent-600 px-5 py-6 md:px-8 md:py-8 text-foreground-950">
          <i className="ri-shield-user-fill absolute -right-4 -top-4 text-[120px] text-accent-700/40" />
          <div className="relative max-w-2xl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-foreground-950 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-lock-2-line" />
              匿名 · 端到端加密
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black leading-tight">
              你有独家线索，就是本站的下一条头条
            </h2>
            <p className="mt-2 text-sm md:text-[15px] text-foreground-900/90">
              投稿、爆料、提供密报或做线人均可在下方选择通道。素材经人工核验并脱敏后发布，线人身份全程保护。
            </p>
            <div className="mt-5 flex flex-col sm:flex-row gap-3">
              <a
                href="#top"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-foreground-950 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-foreground-800 whitespace-nowrap"
              >
                <i className="ri-mail-send-line text-base" />
                立即投稿爆料
              </a>
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-foreground-950/80 px-6 py-3 text-sm font-semibold text-foreground-950 hover:bg-foreground-950 hover:text-background-50 whitespace-nowrap"
              >
                <i className="ri-user-star-line text-base" />
                成为匿名线人
              </a>
            </div>
          </div>
        </div>

        {/* 流程 + 通道 */}
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-5 gap-6 md:gap-8">
          {/* 步骤 */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-6 items-center rounded bg-primary-600 px-2 text-xs font-semibold text-background-50">
                流 程
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">投稿/密报怎么走</h3>
            </div>
            <ol className="mt-5 space-y-0">
              {guideSteps.map((g, i) => (
                <li key={g.no} className="relative flex gap-4 pb-6 last:pb-0">
                  {i !== guideSteps.length - 1 && (
                    <span className="absolute left-[15px] top-8 h-full w-px bg-background-200" />
                  )}
                  <span className="relative flex-none flex h-8 w-8 items-center justify-center rounded-full bg-foreground-950 font-number text-sm font-bold text-background-50">
                    {g.no}
                  </span>
                  <div className="rounded-lg border border-background-200 bg-background-100 flex-1 p-4">
                    <p className="text-sm font-semibold text-foreground-900">{g.title}</p>
                    <p className="mt-1 text-xs md:text-sm leading-relaxed text-foreground-600">{g.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          {/* 通道 */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="inline-flex h-6 items-center rounded bg-accent-500 px-2 text-xs font-semibold text-foreground-950">
                通 道
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">四条投稿入口</h3>
            </div>
            <div className="mt-5 grid grid-cols-1 gap-3">
              {submitChannels.map((c) => (
                <div
                  key={c.name}
                  className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-100 p-4 hover:border-primary-300"
                >
                  <span className="flex h-10 w-10 flex-none items-center justify-center rounded-md bg-primary-600 text-background-50">
                    <i className={`${c.icon} text-lg`} />
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-semibold text-foreground-900">{c.name}</p>
                      <a
                        href="#top"
                        className="inline-flex items-center gap-1 text-xs font-medium text-primary-700 group-hover:text-primary-600"
                      >
                        去提交
                        <i className="ri-arrow-right-up-line" />
                      </a>
                    </div>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{c.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* FAQ */}
        <div className="mt-12">
          <div className="flex items-center gap-2">
            <i className="ri-question-line text-primary-600 text-xl" />
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">投稿 &amp; 线人常见问题</h3>
          </div>
          <div className="mt-5 grid grid-cols-1 lg:grid-cols-2 gap-3">
            {faqs.map((f, idx) => {
              const open = openIdx === idx;
              return (
                <div key={f.q} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(open ? null : idx)}
                    className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left"
                  >
                    <span className="text-sm font-semibold text-foreground-900">{f.q}</span>
                    <i
                      className={`flex-none text-primary-600 transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
                    />
                  </button>
                  {open && <p className="px-4 pb-4 text-xs md:text-sm leading-relaxed text-foreground-600">{f.a}</p>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}